const Section = ({ title, children }) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
    <h2 className="font-heading mb-4 text-2xl font-bold text-[#122A5C]">{title}</h2>
    <div className="space-y-4 leading-relaxed text-slate-700">{children}</div>
  </section>
);

const ExternalLink = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-[#E07000] underline underline-offset-2 hover:text-[#C56200]"
  >
    {children}
  </a>
);

const List = ({ children }) => (
  <ul className="list-disc space-y-2 pl-5">
    {children}
  </ul>
);

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-20 md:py-28" data-testid="datenschutz-page">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <span className="mb-4 inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#E07000]">
            Stand: 23. Juni 2026
          </span>
          <h1 className="font-heading text-3xl font-bold text-[#122A5C] md:text-4xl">
            Datenschutzerklärung
          </h1>
        </div>

        <div className="space-y-6">
          <Section title="1. Verantwortlicher">
            <p>Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser Website ist:</p>
            <p className="font-semibold text-[#122A5C]">Kirsten und Klein eGbR Roofshare Solutions</p>
            <p>handelnd unter der Bezeichnung EN:POWER</p>
            <p>
              Haferfeld 3<br />
              06485 Quedlinburg<br />
              Deutschland
            </p>
            <p>
              Telefon: <a href="tel:+491608732681" className="text-[#E07000] hover:underline">+49 160 8732681</a><br />
              E-Mail: <a href="mailto:info@en-power.eu" className="text-[#E07000] hover:underline">info@en-power.eu</a>
            </p>
            <p>Vertreten durch die vertretungsberechtigten Gesellschafter Randy Wesley Kirsten und Lee-Ann Sophie Klein.</p>
          </Section>

          <Section title="2. Allgemeine Hinweise und Rechtsgrundlagen">
            <p>
              Wir verarbeiten personenbezogene Daten nur, soweit dies für den Betrieb dieser Website, die Bearbeitung von Anfragen, die Vertragsanbahnung oder die Erfüllung gesetzlicher Pflichten erforderlich ist.
            </p>
            <p>
              Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 lit. b DSGVO für vorvertragliche Maßnahmen und Vertragsdurchführung, Art. 6 Abs. 1 lit. c DSGVO für rechtliche Pflichten, Art. 6 Abs. 1 lit. f DSGVO für berechtigte Interessen am sicheren und wirtschaftlichen Betrieb dieser Website sowie Art. 6 Abs. 1 lit. a DSGVO, soweit Sie eine Einwilligung erteilen.
            </p>
          </Section>

          <Section title="3. Aufruf der Website, Hosting und Server-Logfiles">
            <p>
              Beim Aufruf dieser Website werden technisch notwendige Zugriffsdaten verarbeitet. Dazu können insbesondere IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite, Referrer-URL, Browsertyp, Betriebssystem, HTTP-Statuscode und übertragene Datenmenge gehören.
            </p>
            <p>
              Die Verarbeitung dient der Auslieferung der Website, der technischen Stabilität, der Fehleranalyse und der Sicherheit. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Für Betrieb, Wartung und Auslieferung der Website können technische Dienstleister eingesetzt werden, die Zugriff auf Daten nur erhalten, soweit dies für diese Zwecke erforderlich ist.
            </p>
          </Section>

          <Section title="4. Kontakt per Telefon, E-Mail und Anfrageformular">
            <p>
              Wenn Sie uns telefonisch, per E-Mail oder über die Anfragefunktion kontaktieren, verarbeiten wir die von Ihnen übermittelten Angaben. Dazu können Name, E-Mail-Adresse, Telefonnummer, Unternehmen, Projektart, Flächengröße, Standort und Ihre Nachricht gehören.
            </p>
            <p>
              Die Anfrageformulare dieser Website bereiten eine E-Mail in Ihrem eigenen E-Mail-Programm vor. Eine Übermittlung an uns erfolgt erst, wenn Sie die vorbereitete E-Mail selbst absenden. Ihre Angaben können dabei auch durch die von Ihnen und uns eingesetzten E-Mail-Anbieter verarbeitet werden.
            </p>
            <p>
              Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit Ihre Anfrage der Vertragsanbahnung dient, sowie Art. 6 Abs. 1 lit. f DSGVO für unser berechtigtes Interesse an einer effizienten Bearbeitung von Anfragen.
            </p>
          </Section>

          <Section title="5. CRM-System Bitrix24 Cloud">
            <p>
              Zur strukturierten Bearbeitung und Nachverfolgung von Anfragen nutzen wir Bitrix24 Cloud als CRM-System. Anbieter ist Bitrix24, betrieben durch Alaio-Gesellschaften; die konkret zuständige Gesellschaft richtet sich nach der für unser Bitrix24-Konto gewählten Domainzone und den Bitrix24-Vertragsunterlagen. In Bitrix24 können insbesondere Kontakt- und Kommunikationsdaten, Angaben zu Unternehmen, Projektart, Standort, Flächengröße, Anfrageinhalte, Bearbeitungsstatus und interne Notizen verarbeitet werden.
            </p>
            <p>
              Die Verarbeitung dient der Organisation unserer Kunden- und Interessentenkommunikation, der Bearbeitung von Anfragen, der Vertragsanbahnung und der internen Projektverwaltung. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung vorvertraglichen Maßnahmen oder einer Vertragsdurchführung dient, sowie Art. 6 Abs. 1 lit. f DSGVO für unser berechtigtes Interesse an einer effizienten und nachvollziehbaren Anfragebearbeitung.
            </p>
            <p>
              Bitrix24 stellt nach eigenen Angaben Informationen zur DSGVO-Umsetzung und einen Auftragsverarbeitungsvertrag bereit. Nach Anbieterangaben werden Daten in bestimmten europäischen Bitrix24-Domainzonen, insbesondere Bitrix24.eu und Bitrix24.de, in der EU in Frankfurt am Main gehostet. Die konkrete Verarbeitung richtet sich nach der von uns genutzten Bitrix24-Cloud-Region und den dort eingebundenen Unterauftragsverarbeitern.
            </p>
            <p>
              Weitere Informationen finden Sie bei Bitrix24: <ExternalLink href="https://www.bitrix24.com/privacy/">Datenschutzerklärung</ExternalLink>, <ExternalLink href="https://www.bitrix24.com/gdpr/">DSGVO-Informationen</ExternalLink> und <ExternalLink href="https://www.bitrix24.com/legal.php">rechtliche Dokumente</ExternalLink>.
            </p>
          </Section>

          <Section title="6. Pachtrechner und Bildvorschau">
            <p>
              Der Pachtrechner verarbeitet Ihre Eingaben zur Projektart, Flächengröße und Ausrichtung zunächst lokal in Ihrem Browser, um eine unverbindliche Pachtspanne zu berechnen. Eine automatische Übermittlung dieser Berechnung an uns findet nicht statt.
            </p>
            <p>
              Wenn Sie im Pachtrechner ein Bild auswählen, wird dieses zunächst nur lokal in Ihrem Browser als Vorschau angezeigt. Das Bild wird nicht automatisch auf einen Server hochgeladen. Eine Übermittlung erfolgt nur, wenn Sie es anschließend selbst über Ihr E-Mail-Programm versenden oder anhängen.
            </p>
          </Section>

          <Section title="7. Optionale Google-Maps-Kartenvorschau">
            <p>
              Im Pachtrechner kann auf Wunsch eine Kartenvorschau geladen werden. Diese Vorschau wird erst aktiviert, wenn Sie eine Adresse eingeben und die Karten-Vorschau aktiv laden. Ohne diese Aktivierung wird keine Google-Maps-Karte eingebettet.
            </p>
            <p>
              Anbieter ist Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Beim Laden der Karte können insbesondere Ihre IP-Adresse, technische Browserdaten und die eingegebene Adresse an Google verarbeitet werden. Rechtsgrundlage ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
            </p>
            <p>
              Weitere Informationen finden Sie in der Datenschutzerklärung von Google: <ExternalLink href="https://policies.google.com/privacy">https://policies.google.com/privacy</ExternalLink>.
            </p>
          </Section>

          <Section title="8. Cookies, Analyse und Marketing">
            <p>
              Wir setzen nach derzeitigem Stand keine eigenen Analyse-, Tracking- oder Marketing-Cookies ein. Beim bloßen Besuch der Website findet keine Reichweitenmessung durch Google Analytics, Meta Pixel oder vergleichbare Marketingdienste statt.
            </p>
            <p>
              Wenn Sie externe Inhalte wie die optionale Google-Maps-Vorschau laden oder externe Links öffnen, können die jeweiligen Drittanbieter eigene Cookies oder vergleichbare Technologien einsetzen. Darauf haben wir keinen unmittelbaren Einfluss.
            </p>
          </Section>

          <Section title="9. Externe Links">
            <p>
              Diese Website kann Links zu externen Websites enthalten. Wenn Sie einen externen Link öffnen, verlassen Sie unsere Website. Für die Verarbeitung personenbezogener Daten auf externen Websites sind die jeweiligen Anbieter verantwortlich.
            </p>
          </Section>

          <Section title="10. Empfänger und Drittlandübermittlungen">
            <p>
              Empfänger personenbezogener Daten können technische Dienstleister, E-Mail-Anbieter, IT-Dienstleister, CRM-Dienstleister wie Bitrix24 Cloud sowie im Einzelfall Steuer-, Rechts- oder sonstige Berater sein, soweit dies zur Bearbeitung Ihrer Anfrage, zum Betrieb der Website oder zur Erfüllung gesetzlicher Pflichten erforderlich ist.
            </p>
            <p>
              Bei der Nutzung externer Dienste, insbesondere der optionalen Google-Maps-Vorschau oder bei E-Mail-Kommunikation über beteiligte Anbieter, kann eine Verarbeitung außerhalb der Europäischen Union nicht ausgeschlossen werden. In solchen Fällen stützen sich die Anbieter auf die hierfür vorgesehenen datenschutzrechtlichen Garantien.
            </p>
          </Section>

          <Section title="11. Speicherdauer">
            <p>
              Wir speichern personenbezogene Daten nur so lange, wie dies für den jeweiligen Zweck erforderlich ist. Daten aus Anfragen werden gelöscht, wenn die Anfrage abschließend bearbeitet ist, sofern keine gesetzlichen Aufbewahrungspflichten oder berechtigten Interessen an einer weiteren Speicherung bestehen.
            </p>
            <p>
              Technische Logdaten werden nur so lange gespeichert, wie dies für Betrieb, Sicherheit und Fehleranalyse erforderlich ist.
            </p>
          </Section>

          <Section title="12. Ihre Rechte">
            <p>Sie haben im Rahmen der gesetzlichen Voraussetzungen insbesondere folgende Rechte:</p>
            <List>
              <li>Auskunft über die zu Ihrer Person gespeicherten Daten,</li>
              <li>Berichtigung unrichtiger oder unvollständiger Daten,</li>
              <li>Löschung personenbezogener Daten,</li>
              <li>Einschränkung der Verarbeitung,</li>
              <li>Datenübertragbarkeit,</li>
              <li>Widerspruch gegen Verarbeitungen auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO,</li>
              <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft.</li>
            </List>
            <p>
              Sie haben außerdem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen Datenschutzrecht verstößt.
            </p>
          </Section>

          <Section title="13. Pflicht zur Bereitstellung von Daten">
            <p>
              Sie sind weder gesetzlich noch vertraglich verpflichtet, uns über diese Website personenbezogene Daten bereitzustellen. Ohne bestimmte Angaben können wir Ihre Anfrage jedoch möglicherweise nicht oder nicht sinnvoll bearbeiten.
            </p>
          </Section>

          <Section title="14. Automatisierte Entscheidungen">
            <p>
              Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO findet auf dieser Website nicht statt.
            </p>
          </Section>

          <Section title="15. Aktualisierung dieser Datenschutzerklärung">
            <p>
              Wir passen diese Datenschutzerklärung an, wenn sich technische, rechtliche oder organisatorische Änderungen ergeben. Es gilt die jeweils auf dieser Website veröffentlichte Fassung.
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
};
